import React from 'react';

const PageHeaderWithButton = ({ title, children, className, displayFlex }) => (
    <div className="PageHeader row ptb-2">
        <div className={`col-xl-4 col-lg-4 col-sm-12 col-xs-12 p-0 ${className || ``}`}>
            <h4>{title || ``}</h4>
        </div>
        <div className={`col-xl-8 col-lg-8 col-sm-12 col-xs-12 btn-container ${!displayFlex ? `displayBlock`: ``}`}>
            {children}
        </div>
    </div>
)

export default PageHeaderWithButton;